import React from 'react';

import type { ColumnNames } from '../../types/ExtendEnums';
import type {
  VentetiderForBehandlingBehandlingssted,
  BehandlingsstederBehandlingssted,
} from '../../types/helsenorge.velgbehandlingssted.internalapi.entities.entities';

import { Cell } from '@helsenorge/data-table/components/table';

import styles from './styles.module.scss';

export interface BehandlingsstedTabellData {
  behandlingsstedData: VentetiderForBehandlingBehandlingssted & BehandlingsstederBehandlingssted;
  [ColumnNames.Behandlingssted]: string;
}

interface Props {
  rowData?: BehandlingsstedTabellData;
}

export default class BehandlingsstedCell extends React.PureComponent<Props> {
  render(): React.JSX.Element | null {
    const { rowData, ...other } = this.props;

    return (
      <Cell {...other}>
        {rowData && (
          <div className={styles['behandlingssted-cell__data']}>
            <strong>{rowData.behandlingsstedData.navn}</strong>
            <br />

            {!!rowData.behandlingsstedData.besoksAdresse && <span>{rowData.behandlingsstedData.besoksAdresse.gateadresse}</span>}
            {!!rowData.behandlingsstedData.kommune && <span>{`, ${rowData.behandlingsstedData.kommune}`}</span>}
          </div>
        )}
      </Cell>
    );
  }
}
